import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CountUp from "react-countup";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function Statistics() {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);
    UseScrollAnimation();
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <section ref={sectionRef} className="py-[40px]">
            <div className="container flex flex-col gap-[20px]">
                <div className="flex flex-wrap justify-center">
                    <div className="js-scroll fade-top w-full sm:w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                        <div className="flex flex-col items-center">
                            <div className="font-bold capitalize text-[35px]">
                                {isVisible ? <CountUp end={40} duration={6} suffix=" +" /> : "40 +"}
                            </div>
                            <div className="capitalize text-center">{t("years experience")}</div>
                        </div>
                    </div>
                    <div className="js-scroll fade-btm w-full sm:w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                        <div className="flex flex-col items-center">
                            <div className="font-bold capitalize text-[35px]">
                                {isVisible ? <CountUp end={2000} duration={6} suffix=" +" /> : "2000 +"}
                            </div>
                            <div className="capitalize text-center">{t("Plots sold")}</div>
                        </div>
                    </div>
                    <div className="js-scroll fade-top w-full sm:w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                        <div className="flex flex-col items-center">
                            <div className="font-bold capitalize text-[35px]">
                                {isVisible ? <CountUp end={100} duration={6} suffix=" %" /> : "100 %"}
                            </div>
                            <div className="capitalize text-center">{t("inventors satisfaction")}</div>
                        </div>
                    </div>
                    <div className="js-scroll fade-btm w-full sm:w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                        <div className="flex flex-col items-center">
                            <div className="font-bold capitalize text-[35px]">
                                {isVisible ? <CountUp end={100} duration={6} suffix=" %" /> : "100 %"}
                            </div>
                            <div className="capitalize text-center">{t("high ROI")}</div>
                        </div>
                    </div>
                    <div className="js-scroll fade-top w-full sm:w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                        <div className="flex flex-col items-center">
                            <div className="font-bold capitalize text-[35px]">
                                {isVisible ? <CountUp end={15000} duration={6} suffix=" +" /> : "15,000 +"}
                            </div>
                            <div className="capitalize text-center">{t("Residential Units Delivered")}</div>
                        </div>
                    </div>
                    <div className="js-scroll fade-btm w-full sm:w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                        <div className="flex flex-col items-center">
                            <div className="font-bold capitalize text-[35px]">
                                {isVisible ? <CountUp end={500000} duration={6} suffix=" +" /> : "500,000 +"}
                            </div>
                            <div className="capitalize text-center">{t("Square meter of commercial space")}</div>
                        </div>
                    </div>
                    <div className="js-scroll fade-top w-full sm:w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                        <div className="flex flex-col items-center">
                            <div className="font-bold capitalize text-[35px]">
                                {isVisible ? <CountUp end={8.6} decimals={1} duration={6} suffix=" BN" /> : "8.6 BN"}
                            </div>
                            <div className="capitalize text-center">{t("USD in assets")}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}